export enum RccapStatus {    
    MatchHistoryCheck = -1,
    PendingResponse = 1,
    PendingNkrReview = 2,
    NeedsMoreInfo = 4,
    Accepted = 5,
    Draft = 6
}